exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-text-field[data-v-1f065dec]{padding-top:0!important}table.BIPTable[data-v-1f065dec]{border-collapse:collapse}.BIPTable th[data-v-1f065dec],.BIPTable tr td[data-v-1f065dec]{border:1px solid #ccc!important;line-height:20px}.BIPTable tr.textCenter[data-v-1f065dec],.textCenter[data-v-1f065dec]{text-align:center}.BIPTable tr.textBold[data-v-1f065dec],.textBold[data-v-1f065dec]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f065dec","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project_info/bip/insertForm.vue
// module id = 1217
// module chunks = 3